function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clothes-7_svg__id-3a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32 216.743C32 185.405 59.187 160 92.723 160h46.554C172.813 160 200 185.405 200 216.743V232H32v-15.257z",
  fill: "#2BAD62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.551 233.916c-1.759 0-3.185 1.333-3.185 2.967 0 1.644 1.424 2.979 3.185 2.979 1.753 0 3.169-1.335 3.169-2.979 0-1.634-1.414-2.967-3.169-2.967zm0 5.551c-1.551 0-2.68-1.129-2.68-2.586 0-1.446 1.129-2.575 2.68-2.575 1.543 0 2.665 1.129 2.665 2.575.001 1.457-1.121 2.586-2.665 2.586zm1.625-3.362c0-.551-.315-.879-1.255-.879h-1.552v3.317h.434v-1.534h.796l1.016 1.534h.52l-1.073-1.534c.629-.01 1.114-.252 1.114-.904zm-1.709.585h-.662v-1.175h1.014c.436 0 .891.062.891.58 0 .674-.739.595-1.243.595zm9.547-24.174c.001-.689.008-1.638-.197-2.104-.496-1.122-1.016-1.516-2.75-2.699-9.026-6.169-13.165-11.482-14.727-13.483-1.807 1.869-2.051 2.072-2.606 2.495 3.013 3.775 6.297 7.592 13.582 12.963-4.256-.697-10.475-1.488-18.895-5.276.113.05-.509 3.763-.41 3.816 6.24 3.052 11.413 4.159 18.415 5.42-4.628 2.163-9.46 3.856-14.183 5.878.074-.031 1.968 2.777 2.257 3.117 4.986-1.638 9.042-3.142 15.027-6.001 0 .152.092 1.569.092 3.32.015 4.84.239 9.065 1.307 19.836.007.071 2.766.199 3.623.202-.011-.134-.557-24.318-.535-27.484zm29.566-8.105c-8.423 3.787-14.642 4.578-18.893 5.275 7.281-5.37 10.567-9.188 13.582-12.962-.557-.423-.802-.626-2.609-2.496-1.56 2.003-5.7 7.316-14.728 13.484-1.729 1.182-2.251 1.575-2.745 2.698-.206.468-.2 1.416-.197 2.104.023 3.166-.527 27.352-.538 27.482.857-.003 3.615-.131 3.621-.202 1.07-10.77 1.295-14.997 1.309-19.836 0-1.751.091-3.17.091-3.321 5.985 2.859 10.044 4.365 15.025 6.001.292-.339 2.186-3.148 2.262-3.117-4.726-2.022-9.557-3.715-14.187-5.878 7.004-1.262 12.176-2.369 18.416-5.42.101-.051-.52-3.764-.409-3.812zm-21.015-9.018c0-3.531-3.061-6.393-6.833-6.393-3.776 0-6.835 2.862-6.835 6.393 0 3.534 3.059 6.394 6.835 6.394 3.772-.001 6.833-2.86 6.833-6.394z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 116,
  cy: 162,
  rx: 28,
  ry: 12,
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clothes-7_svg__id-3a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h232v232H0z"
})));

function SvgClothes7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/media/clothes-7.2d0760f4.svg";
export { SvgClothes7 as ReactComponent };